import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { GenericState } from '../../../store/generic.state';
import { GenericService } from 'src/app/services/generic.service';
import { GenericActions } from 'src/app/store/generic.actions';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthActions } from 'src/app/store/auth/auth.action';
import { MsalService } from '@azure/msal-angular';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-not-verified',
    templateUrl: './not-verified.component.html',
    styleUrl: './not-verified.component.scss',
    imports: [NzModalModule, NzSpaceModule, NzButtonModule]
})
export class NotVerifiedComponent implements OnInit {
	private readonly store = inject(Store);
	private readonly genericService = inject(GenericService);
	private readonly nzMessage = inject(NzMessageService);
	private readonly authService = inject(MsalService);
	private readonly destroyRef = inject(DestroyRef);

	public isVerifiedVisible = false;
	private userRole: any;

	ngOnInit(): void {
		this.store.select(GenericState.getGeneric).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.userRole = data.userRole;
			if (data.userRole?.emailConfirmed === false) {
				this.isVerifiedVisible = true;
			} else {
				this.isVerifiedVisible = false;
			}
		});
	}

	handleOk(): void {
		this.logout();
		this.isVerifiedVisible = false;
		this.store.dispatch(new GenericActions.UpdateEmailConfirmed(true));
	}

	public resendEmail(): void {
		const payload = {
			value: this.userRole.email
		};
		this.genericService
			.post(`Applicant/ReSendVerificationCode`, payload)
			.subscribe(() => {
				this.nzMessage.success('Verification code sent.');
			});
	}

	logout() {
		localStorage.clear();
		this.authService.logout();
		this.store.dispatch(new AuthActions.SetLogged(false));
	}
}
